/*
 * File: /src/mixins/dates.js
 * Created Date: Sunday August 22nd 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 22nd August 2021 3:03:39 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */
import moment from 'moment';

export function formatDuration(value) {
  const total = Math.max(0, parseInt(value, 10) || 0);
  const hrs = Math.floor(total / 3600);
  const mins = Math.floor((total % 3600) / 60);
  const secs = total % 60;
  if (hrs > 0) {
    return `${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  }
  return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
}

export default {
  methods: {
    relativeTime(date) {
      if (date === undefined || date === null || date === '') return '';
      return moment(date).fromNow();
    },
    cleanDate(i, short = false, dateOnly = false, naive = false) {
      if (i == undefined || i == null) {
        return 'Invalid Date';
      }
      let formatVal = short ? 'll' : 'LL';
      if (dateOnly === false) {
        formatVal += short ? 'l' : 'L';
      }
      // This is used to send raw localized dates to the FE to allow bucketing
      // dates by day correctly in different timezones, ie reporting or whole day dates.
      if (naive) {
        // Chop the timezone off so it will localize to the browsers date with our provided time values
        return moment(new Date(i.slice(0, -1))).format(formatVal);
      }
      return moment(i).local().format(formatVal);
    },
    cleanDateRelativeTime(i, short = false, dateOnly = false, naive = false) {
      if (i == undefined || i == null) {
        return 'Invalid Date';
      }
      const today = moment().startOf('day');
      const dateToCheck = moment(i).startOf('day');
      let formatVal = short ? 'll' : 'LL';
      switch (true) {
        case dateOnly:
          formatVal = short ? 'l' : 'L';
          break;
        case dateToCheck.isSame(today):
          formatVal += short ? ', LT' : ', h:mm:ss A';
          break;
      }
      if (naive) {
        return moment(new Date(i.slice(0, -1))).format(formatVal);
      }
      return moment(i).local().format(formatVal);
    },
  },
};
